var GroupBuilder = /** @class */ (function () {
    function GroupBuilder() {
        this.group = {
            id: 'some-id',
            name: 'Nice Group',
            creationDate: Date.now() - 6000,
            lastUpdateDate: Date.now(),
            membersCount: 2,
        };
    }
    GroupBuilder.prototype.withId = function (id) {
        this.group.id = id;
        return this;
    };
    GroupBuilder.prototype.withName = function (name) {
        this.group.name = name;
        return this;
    };
    GroupBuilder.prototype.withAvatarPath = function (path) {
        this.group.settings = path ? { avatarPath: path } : undefined;
        return this;
    };
    GroupBuilder.prototype.withCreationDate = function (creationDate) {
        this.group.creationDate = creationDate;
        return this;
    };
    GroupBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.group.lastUpdateDate = lastUpdateDate;
        return this;
    };
    GroupBuilder.prototype.withMembersCount = function (membersCount) {
        this.group.membersCount = membersCount;
        return this;
    };
    GroupBuilder.prototype.build = function () {
        return this.group;
    };
    return GroupBuilder;
}());
export { GroupBuilder };
//# sourceMappingURL=group.builder.js.map